import { Link as DefaultLink } from '@twistopayments/design-system/components/atoms/link'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { hiddenDown, styleUtils } from '@twistopayments/design-system/styles'

import type { LinkUrl, LinksLinkComponent } from '@twisto/api-cms'

import { getLinkUrl } from 'homepage/utils'

import * as styles from '../secondary-navigation-slot.styles'

type Props = {
  link: LinksLinkComponent
  increaseFontSize?: boolean
  hideOnMobile?: boolean
}
export const Link = ({
  link,
  increaseFontSize = false,
  hideOnMobile,
}: Props) => (
  <>
    <div
      aria-hidden="true"
      css={[styles.secondaryLinkDivider, hideOnMobile && hiddenDown('xs')]}
    />
    <li css={[hideOnMobile && hiddenDown('xs')]}>
      <DefaultLink
        color="light"
        css={styleUtils.textAlign.center}
        href={link.url}
        target={link.newTab === true ? '_blank' : undefined}
        to={getLinkUrl(link as LinkUrl)}
        underline="hover"
      >
        <Typography component="span" variant={increaseFontSize ? 'b2' : 'b3'}>
          {link.text}
        </Typography>
      </DefaultLink>
    </li>
  </>
)
